import { apiRequest } from './client.js';

/** Branding tracking dashboard — budget against committed work-order value. */

export interface BrandingDashboardRow {
  readonly memberId: string | null;
  readonly memberCode: string | null;
  readonly memberName: string;
  readonly budgetAmount: string;
  readonly committedAmount: string;
  readonly committedQuantity: string;
  readonly unitOfMeasure: string | null;
  readonly workOrderCount: string;
  readonly varianceAmount: string;
  readonly utilisationPct: string | null;
}

export interface DashboardFilters {
  readonly planningCycleId?: string;
  readonly fromDate?: string;
  readonly toDate?: string;
  readonly vendorId?: string;
  readonly brandingTypeId?: string;
  readonly brandingItemId?: string;
  readonly geoNodeId?: string;
}

type Tok = string | null | undefined;

const BASE = '/v1/m17/branding-dashboard';

export function listGroupings(token?: Tok): Promise<readonly string[]> {
  return apiRequest<readonly string[]>(`${BASE}/groupings`, { token });
}

export function loadBrandingDashboard(
  groupBy: string,
  filters: DashboardFilters,
  token?: Tok,
): Promise<readonly BrandingDashboardRow[]> {
  const qs = new URLSearchParams({ groupBy });
  for (const [k, v] of Object.entries(filters)) if (v) qs.set(k, String(v));
  return apiRequest<readonly BrandingDashboardRow[]>(`${BASE}?${qs.toString()}`, {
    token,
  });
}
